module.exports = __webpack_public_path__ + "img/capa1.fa3d679b.webp";